import React from 'react';
import { Youtube, Instagram } from 'lucide-react';
import TikTokIcon from './icons/TikTokIcon';

const StatsBanner = () => {
  return (
    <section className="bg-[#9a6ebd] py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-8">
          <a
            href="https://www.youtube.com/@comprendrelesses"
            target="_blank"
            rel="noopener noreferrer"
            className="flex flex-col items-center text-white hover:opacity-90 transition-opacity"
          >
            <Youtube size={32} className="mb-2" />
            <span className="text-2xl font-bold">6k+</span>
            <span className="text-white/90">Abonnés Youtube</span>
          </a>

          <a
            href="https://www.instagram.com/comprendre_les_ses"
            target="_blank"
            rel="noopener noreferrer"
            className="flex flex-col items-center text-white hover:opacity-90 transition-opacity"
          >
            <Instagram size={32} className="mb-2" />
            <span className="text-2xl font-bold">14k+</span>
            <span className="text-white/90">Abonnés Instagram</span>
          </a>

          <a
            href="https://www.tiktok.com/@comprendre_les_ses"
            target="_blank"
            rel="noopener noreferrer"
            className="flex flex-col items-center text-white hover:opacity-90 transition-opacity"
          >
            <TikTokIcon size={32} className="mb-2" />
            <span className="text-2xl font-bold">37k+</span>
            <span className="text-white/90">Abonnés TikTok</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default StatsBanner;